import { ReactNode } from "react";

interface ShowProps<T> {
  when: T | undefined | null | false;
  fallback?: ReactNode;
  children: ReactNode;
}

export default function Show<T>({ when, fallback = null, children }: ShowProps<T>) {
  return when ? children : fallback;
}
